import { createContext, PropsWithChildren, useContext, useMemo, useState } from "react";

type RecursiveRecord<T = unknown> = {
    [key: string]: T | RecursiveRecord<T>;
};
interface FormaChangeTracker {
    changes: RecursiveRecord | undefined,
    setChanges: (changes: Record<string, unknown>) => void,
    reset: () => void
}

const FormChangeTrackerContext = createContext<FormaChangeTracker>({} as never);

export const FormChangesTrackerProvider = ({ children }: PropsWithChildren) => {
    const [changes, setChanges] = useState<RecursiveRecord>();
    const reset = () => setChanges(undefined)
    const value = useMemo<FormaChangeTracker>(() => {
        return { changes, setChanges, reset };
    }, [changes])
    return <FormChangeTrackerContext.Provider value={value}>{children}</FormChangeTrackerContext.Provider>
}

export const useFormChangesTracker = () => {
    return useContext(FormChangeTrackerContext);
    
}